import React, { useEffect, useState } from "react";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ModalCore } from "src/Pages/components";

import { FormEditarCodProposta } from "./FormEditarCodProposta";
import { UseFormEditarCodProposta } from "./UseFormEditarCodProposta";

interface IModalEditarCodProposta {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  idContract: string;
  onSuccess: () => void;
}

export const ModalEditarCodProposta = ({
  openModal,
  setOpenModal,
  idContract,
  onSuccess,
}: IModalEditarCodProposta) => {
  const { valueContractInternal } = useContextContrato();
  const [codProposta, setCodProposta] = useState("");

  useEffect(() => {
    if (openModal) {
      setCodProposta(valueContractInternal?.cod_proposta ?? "");
    }
  }, [openModal, valueContractInternal?.cod_proposta]);

  const { handleEditarCodProposta, loading } = UseFormEditarCodProposta({
    idContract,
    codProposta,
    setOpenModal,
    onSuccess,
  });

  return (
    <ModalCore
      loadingSubmit={loading}
      open={openModal}
      setOpen={setOpenModal}
      sxStyle={{ width: "600px" }}
      title="Editar código da proposta"
      titleSubmit="Salvar"
      onChange={handleEditarCodProposta}
    >
      <FormEditarCodProposta
        codProposta={codProposta}
        setCodProposta={setCodProposta}
      />
    </ModalCore>
  );
};
